import 'url-search-params-polyfill';

import React, { Component } from 'react';
import { Modal, message } from 'antd';
import Axios from 'axios';
import FileSaver from 'file-saver';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { debounce } from 'lodash';
import RichTextEditor from 'react-rte';
import { createQueryString } from '../../utils/queryStringUtils';
import { tomcatHost, cloudFrontCdnUrl, apiUrl } from '../../config/properties';

import { messageCenterRoute } from '../../config/navigation/routes';
import {
  getConversations,
  getFolderData,
  addFolder,
  deleteFolder,
  moveFolders,
  getDraft,
  putDraft,
  deleteDraft,
  getMessageContents,
  addMessageToConversation,
  addConversation,
  searchConversations,
  markAsRead,
  // getMessageCount,
} from './graphql';
import { forwardTo } from '../../utils/browserHistoryUtils';
// import history from '../../config/history';

// import { addUserRoute, addToolingRoute } from '../../config/navigation/routes';

const { confirm } = Modal;

export default function MessageCenterHOC(MessageCenter) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.any.isRequired,
      location: PropTypes.object.isRequired,
      updateConversation: PropTypes.bool.isRequired,
      updateConversationList: PropTypes.bool.isRequired,
      resetUpdateConversation: PropTypes.func.isRequired,
      setMessageNotification: PropTypes.func.isRequired,
    };

    static initialState = {
      searchText: null,
      rawSelected: {},
      selectedConversations: [],
      selectAll: 0,
      starred: [],
      activeConversation: undefined,
      conversations: [],
      activeKey: ['inbox'],
      openModal: false,
      folders: [],
      confirmLoading: false,
      showMessage: false,
      newFolderName: undefined,
      currentRecipients: [],
      activeDraft: RichTextEditor.createEmptyValue(),
      conversationMessages: null,
      showDeleteAction: false,
      title: null,
      fileList: [],
      showCompose: false,
      errormsg: null,
      attachmentNames: [],
      pageNumber: 0,
      submitting: false,
      downloadingAttachment: false,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const location = this.props.location;
      let conversations = [];
      let folder;
      const id = this.props.auth.id;
      if (location.search) {
        console.log(location.search);
        const params = new URLSearchParams(location.search);

        const messageId = params.get('message');
        folder = params.get('folder');

        if (messageId) {
          this._setSelectedConvo(messageId);
        }
      } else {
        this.setState({ showMessage: false });
      }
      const folderResponse = await getFolderData(id);

      const folders = folderResponse.messageFolders.folderNames;
      const starred = folderResponse.messageFolders.starred;
      if (folder) {
        this._setActiveFolder(folder);
      } else {
        const convoResponse = await getConversations(id);

        conversations = convoResponse.conversations.conversations;
      }
      this.props.setMessageNotification();

      this.setState({
        conversations,
        folders,
        starred,
      });
    }

    // async componentWillReceiveProps(nextProps) {
    //   // if (
    //   //   !nextProps.location.search &&
    //   //   this.props.location.search !== nextProps.location.search
    //   // ) {
    //   //   console.log('here1');
    //   //   this._refreshConversationList();
    //   // }

    //   // if (
    //   //   nextProps.updateConversation !== this.props.updateConversation &&
    //   //   nextProps.updateConversation
    //   // ) {
    //   //   this._getMessages();
    //   //   this.props.resetUpdateConversation();
    //   //   console.log('here2');
    //   // }

    //   // if (
    //   //   nextProps.updateConversationList !==
    //   //   this.props.updateConversationList &&
    //   //   nextProps.updateConversationList
    //   // ) {
    //   //   this._refreshConversationList();
    //   //   this.props.resetUpdateConversation();
    //   //   console.log('here3');
    //   // }
    //   // this.props.setMessageNotification();
    // }

    async componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        const params = new URLSearchParams(this.props.location.search);
        console.log('here4');
        this.props.setMessageNotification();
        // You can access specific parameters:
        const messageId = params.get('message');
        const folder = params.get('folder');

        if (messageId) {
          this._setSelectedConvo(messageId);
          console.log('here5');
        } else if (folder) {
          this._setActiveFolder(folder);
        }
      }

      if (
        prevProps.updateConversationList !==
        this.props.updateConversationList &&
        this.props.updateConversationList
      ) {
        this._refreshConversationList();
        this.props.resetUpdateConversation();
        console.log('here3');
      }

      if (
        prevProps.updateConversation !== this.props.updateConversation &&
        this.props.updateConversation
      ) {
        this._getMessages();
        this.props.resetUpdateConversation();
        console.log('here2');
      }
      // this.props.setMessageNotification();
    }

    _markConversationsRead = async (selectedConversations = null) => {
      let conversationsToMark = selectedConversations;
      if (!conversationsToMark) {
        conversationsToMark = this.state.selectedConversations;
      }
      const id = this.props.auth.id;
      await markAsRead(id, conversationsToMark);
      this._refreshConversationList();
      this.props.setMessageNotification();
    };

    _refreshConversationList = async () => {
      const id = this.props.auth.id;
      console.log('here6');
      const convoResponse = await getConversations(id);
      const conversations = convoResponse.conversations.conversations;
      // const res = await getMessageCount(id);

      // let newMessage = false;
      // if (res.newMsgCount > 0) {
      //   newMessage = true;
      // }
      this.props.setMessageNotification();
      this.setState({
        conversations,
        showMessage: false,
        showCompose: false,
      });
    };

    _getSelectedConversations = solicitationArr => {
      const newArr = [...solicitationArr];
      console.log('this is the select array');
      this.setState({
        selectedConversations: newArr,
      });
    };

    _selectAllConversationsInFolder = () => {
      const conversations = [...this.state.conversations];
      const newSelected = {};

      conversations.forEach(x => {
        newSelected[x.id] = true;
      });
      this.setState({
        rawSelected: newSelected,
        selectedConversations: Object.keys(newSelected),
      });
    };

    _changeSelectAllValue = (rawSelected, value) => {
      console.log(value);

      this.setState({
        rawSelected,
        selectedConversations: Object.keys(rawSelected),

        selectAll: value,
      });
    };

    _setPageInfo = page => {
      this.setState({ pageNumber: page.page });
    };

    _setActiveFolder = async e => {
      const id = this.props.auth.id;
      let value = e;
      if (e.key) {
        value = e.key;
      }
      console.log('I am the value being called', e);
      if (value === 'folder-add') {
        this.setState({ openModal: true });
        return;
      }
      console.log(value);
      const stateObj = {
        activeKey: [value],
      };
      if (value.includes('folder')) {
        stateObj.showCompose = false;
        stateObj.showMessage = false;

        stateObj.showDeleteAction = true;
        const convoResponse = await getConversations(
          id,
          value.substring(value.indexOf('-') + 1),
        );
        const conversations = convoResponse.conversations.conversations;
        stateObj.conversations = conversations;
        this.setState({ ...stateObj });
      }

      if (value === 'starred' || value === 'archived') {
        stateObj.showDeleteAction = false;
        stateObj.showCompose = false;
        stateObj.showMessage = false;

        const convoResponse = await getConversations(id, value);
        const conversations = convoResponse.conversations.conversations;
        stateObj.conversations = conversations;
        this.setState({ ...stateObj });
      }
      if (value === 'inbox') {
        stateObj.showCompose = false;
        stateObj.showMessage = false;
        stateObj.activeConversation = null;

        this.setState({
          attachmentNames: [],
          fileList: [],
          activeDraft: RichTextEditor.createEmptyValue(),
        });
        const convoResponse = await getConversations(id);
        const conversations = convoResponse.conversations.conversations;
        stateObj.conversations = conversations;
        this.setState({ ...stateObj });

        forwardTo(messageCenterRoute);
      }
      if (value === 'newMessage') {
        console.log('this is newMessage');
        stateObj.conversationMessages = null;
        stateObj.showCompose = true;
        stateObj.showMessage = false;
        stateObj.activeDraft = RichTextEditor.createEmptyValue();
        stateObj.activeConversation = null;
        this.setState({ ...stateObj });

        this._setSelectedConvo('compose');

        return;
      }

      if (value === 'drafts') {
        stateObj.showMessage = false;
        stateObj.showCompose = false;

        const convoResponse = await getConversations(id, 'drafts');

        const conversations = convoResponse.conversations.conversations;
        console.log(conversations);

        stateObj.conversations = conversations;
        this.setState({ ...stateObj });
      }
      this._changeQueryString(value, 'folder');
    };
    // TODO: "fix when ypu click on an empty row it breaks "

    _selectedAction = (action, id = null, folderName = null) => {
      console.log(action, id, folderName);
      console.log('root function');
      const that = this;
      switch (action) {
        case 'newMessage':
          this._setSelectedConvo('compose');
          break;
        case 'moveTo':
          this.moveToFolder(folderName);
          break;
        case 'markAsRead':
          this._markConversationsRead();
          break;
        case 'reply':
          this._setSelectedConvo(id);
          break;
        case 'delete':
          this.moveToFolder('archived', [id]);
          break;
        case 'deleteFolder':
          confirm({
            title: 'Are you sure delete this Folder?',
            content:
              'This action is Irreversible and content will be returned to inbox',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
              that.deleteFolder();
            },
            onCancel() {
              console.log('Cancel');
            },
          });
          break;
        case 'deleteDrafts':
          this._deleteDrafts();
          break;
        default:
          break;
      }
    };

    _deleteDrafts = async () => {
      const { selectedConversations } = this.state;

      console.log(selectedConversations);
      await deleteDraft(this.props.auth.id, selectedConversations);
      const convoResponse = await getConversations(
        this.props.auth.id,
        'drafts',
      );

      const conversations = convoResponse.conversations.conversations;
      console.log(conversations);

      this.setState({
        conversations,
        selectedConversations: [],
        selectAll: 0,
      });
    };

    _changeQueryString = (value, key = 'message') => {
      console.log(this.props.location);
      let url;
      const params = new URLSearchParams(this.props.location.search);
      // You can access specific parameters:
      const messageId = params.get('message');
      console.log(messageId, value);
      if (messageId === value) {
        return;
      }
      console.log('I shouldnt get here');
      if (value !== 'inbox') {
        url = `${messageCenterRoute}?${createQueryString({
          [key]: value,
        })}`;
      } else {
        this.setState({
          attachmentNames: [],
          fileList: [],
          activeDraft: RichTextEditor.createEmptyValue(),
        });
        url = `${messageCenterRoute}`;
      }
      forwardTo(url);
    };

    _setSelectedConvo = async convoId => {
      let fileList = [];
      console.log('heree for compose');

      await this._getMessages(convoId);
      console.log('HERE');
      let messageContents = null;
      if (this.state.conversationMessages) {
        messageContents = this.state.conversationMessages.convoEntriesHeader
          .convoEntriesList[0];
      }
      if (!convoId) {
        this.setState({
          // activeConversation: convoId,
          showCompose: false,
          showMessage: false,
          activeDraft: RichTextEditor.createEmptyValue(),
          title: null,
          currentRecipients: [],
        });
        return;
      }
      if (!messageContents) {
        this.setState({
          activeConversation: convoId,
          showCompose: true,
          showMessage: false,
        });
      }

      this._changeQueryString(convoId);
      let res;
      if (convoId === 'compose') {
        this.setState({ activeKey: ['newMessage'] });
      } else {
        res = await getDraft(this.props.auth.id, convoId);
        console.log(res.getDraft);
        if (res.getDraft && res.getDraft.entry) {
          this.setState({
            activeDraft: RichTextEditor.createValueFromString(
              res.getDraft.entry,
              'html',
            ),
          });
        } else {
          this.setState({
            activeDraft: RichTextEditor.createEmptyValue(),
          });
        }

        if (res.getDraft && res.getDraft.attachments) {
          fileList = res.getDraft.attachments.map(str => JSON.parse(str));
        }
      }

      if (messageContents) {
        this.setState({
          activeConversation: convoId,
          showMessage: true,
          fileList,
        });
        this._getMessages(convoId);
      } else if (convoId === 'compose' || !messageContents) {
        let title = null;
        let currentRecipients = [];
        if (res && res.getDraft && res.getDraft.title) {
          title = res.getDraft.title;
        }
        if (res && res.getDraft && res.getDraft.recepients) {
          currentRecipients = res.getDraft.recepients;
        }
        console.log('I should be getting here');
        this.setState({
          // activeConversation: convoId,
          showCompose: true,
          showMessage: false,
          title,
          currentRecipients,
          fileList,
        });
      }
    };

    convertUTCDateToLocalDate = messageContents => {
      if (
        messageContents &&
        messageContents.convoEntriesHeader.convoEntriesList
      ) {
        const convoEntries = [
          ...messageContents.convoEntriesHeader.convoEntriesList,
        ];
        console.log(convoEntries);

        const updatedEntrys = convoEntries.map(entry => {
          const newDate = moment
            .utc(`${entry.created}.000Z`)
            .local()
            .format('MM-DD-YYYY hh:mm:ss a');

          return { ...entry, created: newDate };
        });
        return updatedEntrys;
      }
      // const newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

      // var offset = date.getTimezoneOffset() / 60;
      // var hours = date.getHours();

      // newDate.setHours(hours - offset);

      return 'newDate';
    };

    _getMessages = async (convoId = null) => {
      if (convoId === 'compose') {
        return;
      }
      const userId = this.props.auth.id;

      let conversationId = convoId;
      if (!conversationId) {
        conversationId = this.state.activeConversation;
      }

      const res = await getMessageContents(userId, conversationId);
      const updatedEntries = this.convertUTCDateToLocalDate(
        res.messageContents,
      );
      res.messageContents.convoEntriesHeader.convoEntriesList = updatedEntries;
      this.setState({
        conversationMessages: res.messageContents,
      });
    };

    _downloadAttachments = async (messageId, attachmentId, attachmentName) => {
      this.setState({ downloadingAttachment: true });

      await Axios.get(
        `${cloudFrontCdnUrl}/${tomcatHost}/conversations/attachment/${this.state.activeConversation
        }/${messageId}/${attachmentId}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${this.props.auth.jwtToken}`,
          }
        },
      ).then(res => {
        this.setState({ downloadingAttachment: false });
        const data = res.data;

        const blob = new Blob([data], { type: 'octet/stream' });
        console.log(blob, attachmentName);
        if (navigator.msSaveBlob) {
          // For IE
          console.log('here');
          navigator.msSaveBlob(blob, attachmentName);
        } else {
          FileSaver.saveAs(blob, attachmentName);
        }

      });


      // } catch (err) {
      //   console.log(err);
      // }
    };

    // _downloadAttachments = async (messageId, attachmentId, attachmentName) => {
    //   console.log(this.state.activeConversation);
    //   console.log(messageId, attachmentId);
    //   try {
    //     const res = await Axios.get(
    //       `${cloudFrontCdnUrl}/${tomcatHost}/conversations/attachment/${this.state.activeConversation
    //       }/${messageId}/${attachmentId}`,
    //       {
    //         responseType: 'blob',
    //         headers: {
    //           Authorization: `Bearer ${this.props.auth.jwtToken}`,
    //         }
    //       },
    //     );

    //     const data = res.data;

    //     // const a = document.createElement('a');
    //     // document.body.appendChild(a);
    //     // a.style = 'display: none';

    //     const blob = new Blob([data], { type: 'octet/stream' });
    //     console.log(blob, attachmentName);
    //     if (navigator.msSaveBlob) {
    //       // For IE
    //       console.log('here');
    //       navigator.msSaveBlob(blob, attachmentName);
    //     } else {
    //       FileSaver.saveAs(blob, attachmentName);
    //     }
    //     //   const url = window.URL.createObjectURL(blob);
    //     //   a.href = url;
    //     //   a.download = attachmentName;
    //     //   a.click();
    //     //   window.URL.revokeObjectURL(url);
    //     //   return true;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };

    deleteFolder = async () => {
      console.log('its delete time');
      const folderName = this.state.activeKey[0].substring(
        this.state.activeKey[0].indexOf('-') + 1,
      );
      const res = await deleteFolder(this.props.auth.id, folderName);
      this.setState({
        folders: res.deleteFolder.folderNames,
      });
      const e = {};
      e.key = 'inbox';
      this._setActiveFolder(e);
    };

    moveToFolder = async (folderName, arrayOfIds = null) => {
      let { selectedConversations } = this.state;
      console.log(folderName);
      if (arrayOfIds) {
        selectedConversations = arrayOfIds;
      }
      let targetFolderName = folderName;
      if (targetFolderName === 'folder-remove') {
        targetFolderName = 'REMOVE';
      }
      if (targetFolderName === 'inbox') {
        targetFolderName = undefined;
      }
      console.log(selectedConversations);

      if (this.state.activeKey[0] === 'drafts') {
        console.log('here');
        await this._deleteDraft(arrayOfIds);
        await moveFolders(
          this.props.auth.id,
          selectedConversations,
          targetFolderName.substring(targetFolderName.indexOf('-') + 1),
        );
        if (targetFolderName === 'archived' && this.state.activeKey[0] !== 'drafts') {
          // convoResponse = await getConversations(this.props.auth.id);
          console.log('marked as read');
          await markAsRead(this.props.auth.id, selectedConversations);
          // this._markConversationsRead(selectedConversations);

        }
      }
      let convoResponse;
      console.log("cAHTARINA  cHECKPOINT")

      if (this.state.activeKey[0] === 'inbox') {
        convoResponse = await getConversations(this.props.auth.id);
      } else {
        console.log(
          "tHE ACTIVE KEY",
          this.state.activeKey[0].substring(
            this.state.activeKey[0].indexOf('-') + 1,
          ),
        );
        convoResponse = await getConversations(
          this.props.auth.id,

          this.state.activeKey[0].substring(
            this.state.activeKey[0].indexOf('-') + 1,
          ),
        );
      }
      console.log(convoResponse);
      const conversations = convoResponse.conversations.conversations;
      this.setState({
        conversations,
        selectedConversations: [],
        selectAll: 0,
        rawSelected: {},
      });
    };

    _handleCancel = () => {
      this.setState({ openModal: false });
    };

    _handleFolderNameSubmission = async () => {
      this.setState({ confirmLoading: true });
      let folderNameExists = false;
      this.state.folders.forEach(element => {
        if (
          element.replace(/ /g, '').toLowerCase() ===
          this.state.newFolderName.replace(/ /g, '').toLowerCase()
        ) {
          folderNameExists = true;
        }
      });

      if (folderNameExists) {
        message.error('Folder with that name already exists');
        this.setState({
          confirmLoading: false,
          openModal: false,
        });
        return;
      }
      const res = await addFolder(this.props.auth.id, this.state.newFolderName);
      this.setState({
        confirmLoading: false,
        openModal: false,
        folders: res.addFolder.folderNames,
      });
    };

    _handleFolderNameChange = e => {
      const newFolderName = e.target.value;
      this.setState({ newFolderName });
    };

    _markConversationsStarred = async conversation => {
      const starredArray = [...this.state.starred];
      const index = starredArray.indexOf(conversation);
      if (index !== -1) {
        starredArray.splice(index, 1);
        this.setState({ starred: starredArray });
      } else {
        starredArray.push(conversation);
        this.setState({
          starred: starredArray,
        });
      }
      this.moveToFolder('starred', starredArray);
    };

    _saveDraft = debounce(async () => {
      // turns out to use the debounce the context that is being called is the banner and not the HOC so in order to get the jwt token I need auth to be on the context of banner ¯\_(ツ)_/¯

      if (this.state.activeDraft.toString('html') === '<p><br></p>') {
        console.log('message empty, not saving draft');
        return;
      }

      if (!this.state.currentRecipients.length) {
        console.log('recipient empty, not saving draft');
        return;
      }

      const fileList = this.state.fileList.map(obj => JSON.stringify(obj));
      const convoId = this.state.activeConversation || 'compose';
      console.log(convoId);
      const res = await putDraft(
        this.props.auth.id,
        convoId,
        this.state.activeDraft.toString('html'),
        fileList || null,
        this.state.title || null,
        this.state.currentRecipients || null,
      );
      console.log(res.putDraft.convoId);
      this.setState({
        activeConversation: res.putDraft.convoId,
      });
    }, 600);

    _onChangeDraft = value => {
      console.log('_onChangeDraft gets called');
      console.log(value);
      this.setState({ activeDraft: value });
      if (!this.state.currentRecipients.length) {
        this.setState({
          errormsg: 'The draft will not be saved until you select a recipient',
        });
      }
    };

    _onCompose = () => {
      this.setState({ showCompose: false, title: null });
      this._refreshConversationList();
    };

    _deleteDraft = async (id = null) => {
      this._saveDraft.cancel();
      let convoId;
      if (id) {
        convoId = id;
      } else {
        convoId = [this.state.activeConversation];
      }
      console.log(convoId);
      await deleteDraft(this.props.auth.id, convoId);
      this.setState({
        activeDraft: RichTextEditor.createEmptyValue(),
        title: null,
        currentRecipients: [],
      });
      // this._setActiveFolder({ key: 'inbox' });
    };

    addMessageToConvo = async attachments => {
      const res = await addMessageToConversation(
        this.props.auth.id,
        this.state.activeConversation,
        this.state.activeDraft.toString('html'),
        attachments,
      );
      console.log("addMessageToConvo", res)

      // const updatedEntries = this.convertUTCDateToLocalDate(res.addMessage);
      // if (res.addMessage && res.addMessage.convoEntriesHeader)
      //   res.addMessage.convoEntriesHeader.convoEntriesList = updatedEntries;
      this.setState({
        // conversationMessages: res.addMessage,
        attachmentNames: [],
        fileList: [],
        showCompose: false,
        showMessage: true,
      });
      this._getMessages();
    };

    addConvoThenMsg = async attachments => {
      try {
        const res = await addConversation(
          this.props.auth.id,
          this.state.title,
          this.state.activeDraft.toString('html'),
          this.state.currentRecipients,
          attachments,
        );

        if (res.addConversation && res.addConversation.errors) {
          this.setState({ errormsg: res.addConversation.errors.msg });
        }

        this.setState({
          attachmentNames: [],
          fileList: [],

          // showMessage: false,
          // showCompose: false,
          // conversations: res.addConversation.conversations,
        });
      } catch (err) {
        console.log(err);
        this.setState({
          errormsg: 'Something went wrong please try again',
          submitting: false,
        });
      }

      // this.setState({
      //   showCompose: false,
      // });

      this._refreshConversationList();

      this._changeQueryString('inbox', 'folder');
    };

    handleSubmitErrors = attachments => {
      if (
        this.state.activeConversation &&
        this.state.activeConversation !== 'compose'
      ) {
        if (
          this.state.activeDraft.toString('html') === '<p><br></p>' &&
          !attachments[0]
        ) {
          this.setState({
            errormsg:
              'please compose a message or add attachments before sending',
          });

          return true;
        }
      } else {
        if (!this.state.currentRecipients.length) {
          this.setState({
            errormsg: 'please pick a recepient of this message',
            submitting: false,
          });

          return true;
        }
        if (!this.state.title) {
          this.setState({
            errormsg: 'please add a subject',
            submitting: false,
          });

          return true;
        }
        if (
          this.state.activeDraft.toString('html') === '<p><br></p>' &&
          !attachments[0]
        ) {
          this.setState({
            errormsg:
              'please compose a message or add attachments before sending',
            submitting: false,
          });

          return true;
        }
      }
      return false;
    };

    // gets called on submit
    _addMessage = async () => {
      this.setState({
        submitting: true,
      });
      const attachments = [...this.state.attachmentNames];

      if (this.handleSubmitErrors(attachments)) {
        this.setState({
          submitting: false,
        });
        return;
      }
      if (
        this.state.activeConversation &&
        this.state.activeConversation !== 'compose'
      ) {
        console.log("addMessageToConvo")
        this.addMessageToConvo(attachments);

      } else {
        console.log("addConvoThenMsg")
        this.addConvoThenMsg(attachments);
      }
      this._deleteDraft();

      this.setState({
        submitting: false,
      });
    };

    _setCurrentRecipients = cage => {
      this.setState({ currentRecipients: [cage] });
      this._saveDraft();
    };

    _setTitle = e => {
      console.log(e.target.value);
      this.setState({ title: e.target.value });
    };

    _setSearchText = e => {
      console.log(e.target.value);
      if (!e.target.value) {
        this.setState({ searchText: '' });
      } else {
        this.setState({ searchText: e.target.value });
      }
    };

    _requestSearch = async text => {
      console.log(text);
      let conversations;
      if (text) {
        const searchResponse = await searchConversations(
          this.props.auth.id,
          text,
        );
        conversations = searchResponse.search.conversations;
      } else {
        const convoResponse = await getConversations(this.props.auth.id);
        console.log(convoResponse);
        conversations = convoResponse.conversations.conversations;
      }
      this.setState({
        showMessage: false,
        showCompose: false,
        conversations,
      });
      this._changeQueryString('inbox');
    };

    _onCloseError = () => {
      this.setState({ errormsg: null });
    };

    _onRemove = file => {
      console.log(this.state.attachmentNames);
      console.log(file);

      this.setState(state => {
        const index1 = state.attachmentNames.indexOf(
          file.name.replace('(.*)-[^-]*', ''),
        );
        const newattachmentNames = state.attachmentNames.slice();
        newattachmentNames.splice(index1, 1);
        console.log(newattachmentNames);
        const index = state.fileList.indexOf(file);
        const newFileList = state.fileList.slice();
        newFileList.splice(index, 1);
        return {
          fileList: newFileList,
          attachmentNames: newattachmentNames,
        };
      });
    };

    _handleUploadChange = info => {
      console.log("_handleUploadChange  info", info);
      let fileList = [...info.fileList];
      if (info.file.size > 26214400) {
        console.log(info.file.uid);
        const arr = fileList.filter(obj => obj.uid !== info.file.uid);
        fileList = arr;
        this.setState({
          errormsg: 'File exceeds 25MB size limit.',
          submitting: false,
        });
      }

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      console.log(fileList);
      // 2. Read from response and show file link

      if (fileList.length > 10) {
        this.setState({
          submitting: false,
          errormsg: 'Only ten attachments allowed at a time.',
        });
        fileList = fileList.slice(0, 10);
      }

      this.setState({ fileList });
    };

    _getPresignedPostData = async selectedFile => {
      const fileName = `${this.props.auth.id.replace(/-/g, '')}-${selectedFile.name
        }`;
      const attachmentNames = [...this.state.attachmentNames];

      attachmentNames.push(fileName);
      this.setState({
        attachmentNames,
      });
      try {
        const res = await Axios.post(`${apiUrl}conversation/getpresignedUrl`, {
          name: fileName,
          type: selectedFile.type,
        });

        return res.data;
      } catch (error) {
        console.error(error);
        return null;
      }

    };

    _handleUpload = async option => {
      console.log('here');
      this.setState({
        submitting: true,
      });
      const { onSuccess, onError, file, onProgress } = option;
      const reader = new FileReader();
      if (file.size > 26214400) {
        return;
      }
      if (this.state.fileList.length > 10) {
        return;
      }
      onProgress({ percent: 1 }, file);
      reader.readAsDataURL(file);

      const presignedPostData = await this._getPresignedPostData(file);

      const fd = new FormData();
      Object.keys(presignedPostData.fields).forEach(key => {
        console.log(key);
        fd.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      fd.append('file', file);
      console.log(fd.values());

      const config = {
        url: `${presignedPostData.url}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },

        data: fd,
        onUploadProgress: ({ total, loaded }) => {
          onProgress(
            { percent: Math.round((loaded / total) * 100).toFixed(2) },
            file,
          );
        },
      };

      try {
        const res = await Axios(config);
        console.log(res);
        onSuccess(res.data);
        this.setState({
          submitting: false,
        });
      } catch (error) {
        console.log(error);
        onError(error);
        this.setState({
          submitting: false,
        });
      }
    };

    render() {
      const {
        rawSelected,
        selectAll,
        selectedConversations,
        starred,
        conversations,
        activeKey,
        openModal,
        folders,
        showDeleteAction,
        showMessage,
        activeConversation,
        confirmLoading,
        activeDraft,
        errormsg,
        conversationMessages,
        showCompose,
        searchText,
        title,
        currentRecipients,
        fileList,
        pageNumber,
        submitting,
        downloadingAttachment,
      } = this.state;
      const pageProps = {
        activeDraft,
        currentRecipients,
        handleCancel: this._handleCancel,
        handleFolderNameSubmission: this._handleFolderNameSubmission,
        rawSelected,
        fileList,
        conversationMessages,
        conversations,
        errormsg,
        setMessageNotification: this.props.setMessageNotification,
        searchText,
        selectedConversations,
        selectAll,
        showCompose,
        confirmLoading,
        activeConversation,
        showMessage,
        showDeleteAction,
        submitting,
        folders,
        openModal,
        pageNumber,
        activeKey,
        auth: this.props.auth,
        title,
        setTitle: this._setTitle,
        deleteDraft: this._deleteDraft,
        onChangeDraft: this._onChangeDraft,
        setSelectedConvo: this._setSelectedConvo,
        setPageInfo: this._setPageInfo,
        handleFolderNameChange: this._handleFolderNameChange,
        selectedAction: this._selectedAction,
        setActiveFolder: this._setActiveFolder,
        getSelectedConversations: this._getSelectedConversations,
        changeSelectAllValue: this._changeSelectAllValue,
        saveDraft: this._saveDraft,
        addMessage: this._addMessage,
        setCurrentRecipients: this._setCurrentRecipients,
        starred,
        onCompose: this._onCompose,
        markConversationsStarred: this._markConversationsStarred,
        onCloseError: this._onCloseError,
        setSearchText: this._setSearchText,
        downloadAttachments: this._downloadAttachments,
        requestSearch: this._requestSearch,
        handleUpload: this._handleUpload,
        handleUploadChange: this._handleUploadChange,
        onSubmit: this._onSubmit,
        onRemove: this._onRemove,
        selectAllConversationsInFolder: this._selectAllConversationsInFolder,
        downloadingAttachment,
      };
      return <MessageCenter {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/messageCenter/MessageCenterHOC.jsx